<template>
  <div class="main" v-if="schedulheadInfo">
    <div class="header ub-box ub-row">
      <div class="left">
        <img src="../../assets/img/doc.png" />
      </div>
      <div class="right ub-flex-1 ub-box ub-col">
        <div class="doc-info ub-box ub-row">
          <div class="doc-info-right">
            <div class="doc-name">
              {{ schedulheadInfo.docName || schedulheadInfo.deptName }}
            </div>
            <div class="regLevel-name">{{ schedulheadInfo.regLevelName }}</div>
          </div>
          <div class="status" v-if="!isToday(schedulheadInfo.seeDate)">可预约</div>
          <div
            class="status"
            v-if="
              isToday(schedulheadInfo.seeDate) &&
              new Date().getTime() <
                new Date(schedulheadInfo.visitEndTime.replace(/-/g, '/')).getTime()
            "
          >
            可挂号
          </div>
          <div
            class="status"
            style="color: #a5b1c2"
            v-if="
              isToday(schedulheadInfo.seeDate) &&
              new Date().getTime() >=
                new Date(schedulheadInfo.visitEndTime.replace(/-/g, '/')).getTime()
            "
          >
            不可挂号
          </div>
        </div>
      </div>
    </div>
    <div class="border ub-box ub-col">
      <div class="item ub-box ub-ver-v ub-between">
        <div>科室名称</div>
        <div>{{ schedulheadInfo.deptName }}</div>
      </div>
      <div class="item ub-box ub-ver-v ub-between">
        <div>可预约人数</div>
        <div>{{ appointLimit }}</div>
      </div>
      <div class="item ub-box ub-ver-v ub-between">
        <div>已挂号人数</div>
        <div>{{ schedulheadInfo.appointReg }}</div>
      </div>
      <div class="item ub-box ub-ver-v ub-between">
        <div>就诊开始时间</div>
        <div>{{ schedulheadInfo.visitBeginTime }}</div>
      </div>
      <div class="item ub-box ub-ver-v ub-between">
        <div>就诊结束时间</div>
        <div>{{ schedulheadInfo.visitEndTime }}</div>
      </div>
      <div class="item ub-box ub-ver-v ub-between">
        <div>已预约人数</div>
        <div>{{ schedulheadInfo.appointReging }}</div>
      </div>
      <div class="item ub-box ub-ver-v ub-between">
        <div>费用</div>
        <div class="money">￥ {{ schedulheadInfo.regFee }}</div>
      </div>
    </div>
    <div class="footer">
      <van-button
        round
        block
        type="primary"
        size="nomal"
        v-if="!isToday(schedulheadInfo.seeDate)"
        @click="handleYuyue"
        >立即预约</van-button
      >
      <van-button
        round
        block
        type="default"
        size="nomal"
        style="background: #a5b1c2; color: #fff"
        v-if="
          new Date().getTime() >=
          new Date(schedulheadInfo.visitEndTime.replace(/-/g, '/')).getTime()
        "
        >不可预约</van-button
      >
      <van-button
        round
        block
        type="default"
        size="nomal"
        style="background: #a5b1c2; color: #fff"
        v-if="
          isToday(schedulheadInfo.seeDate) &&
          new Date().getTime() >=
            new Date(schedulheadInfo.visitEndTime.replace(/-/g, '/')).getTime()
        "
        >不可挂号</van-button
      >
      <van-button
        round
        block
        type="primary"
        size="nomal"
        v-if="
          isToday(schedulheadInfo.seeDate) &&
          new Date().getTime() <
            new Date(schedulheadInfo.visitEndTime.replace(/-/g, '/')).getTime()
        "
        @click="handleYuyue"
        >立即挂号</van-button
      >
    </div>
    <div class="popup">
      <van-popup
        v-model="show"
        position="bottom"
        :style="{ height: '33%' }"
        class="ub-box ub-col"
      >
        <div class="cancel-confirm ub-box ub-between">
          <div
            class="cancel"
            @click="
              () => {
                show = false;
              }
            "
          >
            取消
          </div>
          <div class="confirm" @click="handleConfirm">确认</div>
        </div>
        <!-- {{medicalcardInfo}} -->
        <van-radio-group
          v-model="radio"
          class="ub-flex-1"
          style="overflow-x: hidden; overflow-y: auto"
        >
          <van-cell-group>
            <van-cell
              clickable
              v-for="(item, index) in medicalcardInfo"
              :key="index"
              @click="getmedCardNo(item.medCardNo)"
              :title="item.clientName + ' - ' + item.medCardNo"
            >
              <template #right-icon>
                <van-radio :name="index" />
              </template>
            </van-cell>
          </van-cell-group>
        </van-radio-group>
      </van-popup>
    </div>
  </div>
</template>

<script>
import setOptions from "./../../mixins/setOption";
import payMixin from "./../../mixins/pay";
export default {
  mixins: [setOptions, payMixin],
  data() {
    return {
      schedulheadInfo:null,
      show: false,//患者选择弹窗显示或隐藏
      radio: "",
      appointLimit: 0,
      medCardNo:null,
      medicalcardInfo: [],
      isDiffNoonDoc: true,
    };
  },
  async mounted() {
    await this.getmedicalcard();
    await this.getSchedulheadList();
  },
  methods: {
    //获取患者编号
    async getmedCardNo(medCardNo){
      if(!medCardNo){
        this.medCardNo = null;
      }else{
        this.medCardNo = medCardNo;
      }
    },
    //立即预约处理函数
    async handleYuyue() {
      if (this.medicalcardInfo.length <= 0) {
        this.$toast.fail("未绑定就诊卡");
        setTimeout(() => {
          this.$router.push("/cardList");
        }, 1000);
      } else {
        this.show = true;
      }
    },
    //选择患者确认处理函数  
    async handleConfirm() {
      if(!this.medCardNo){
        this.$toast.fail("请选择挂号用户");
        return;
      }
      if (this.appointLimit === 0) {
        await setTimeout(() => {
          this.$router.push("/schedulhead");
        }, 1500);
        this.$toast.fail("可预约人数为零，不可预约");
      } else {
        this.show = false;
        this.$showLoad();
        // 查询当前卡预约信息 --- 在已有预约的情况下，不可重复挂号
        let registerList = await this.$axios.get(
          `/register/getUserRegisterList?medCardNo=${this.medCardNo}`
        );
        // console.log(registerList);
        if (registerList.status === 200) {
          let rList = registerList.data
            .filter((item) => item.regDate === this.schedulheadInfo.seeDate)
            .filter((item) => item.deptId === this.schedulheadInfo.deptId)
            .filter((item) => item.docId === this.schedulheadInfo.docId);
          if (rList.length > 0) {
            this.$hideLoad();
            if (rList[0]["payFlag"] === "0") {
              this.$toast.fail(
                "您有未支付的预约挂号订单，请前往费用支付菜单查看"
              );
            }
          }
        }
        let new_seeDate = new Date(this.schedulheadInfo.seeDate);
        new_seeDate.setTime(new_seeDate.setHours(new_seeDate.getHours() + 8));
        // 锁号
        let requestData = {
          schedulId: this.schedulheadInfo.schedulId,
          seeDate: new_seeDate.toISOString(),
          regTypeId: this.schedulheadInfo.docId !== "None" ? "1" : "0",
          deptId: this.schedulheadInfo.deptId,
          docId: this.schedulheadInfo.docId,
          regWay: "05",
          clientId: this.medCardNo,
          regLevelId: this.schedulheadInfo.regLevelId,
          deptName: this.schedulheadInfo.deptName,
          isDiffNoonDoc: false,
        };
        if (!!this.schedulheadInfo.noonCode) {
          (requestData.isDiffNoonDoc = true),
            (requestData.noonId = this.schedulheadInfo.noonCode);
        }
        try {
          let rept = await this.$axios.post(
            "/register/locknumber",
            requestData
          );
          this.$hideLoad();
          console.log(rept);
          if (rept.status === 200 && rept.code != -1) {
            this.$dialog
              .confirm({
                title: "支付",
                message:
                  "锁定预约号成功，是否立即支付？（可稍后在费用支付菜单中支付）",
              })
              .then(() => {
                this.getPreTradeNo(this.medCardNo, rept.data.preId);
              })
              .catch(() => {
                console.log("暂不支付");
              });
          } else {
            setTimeout(() => {
              this.$router.go(-1);
            }, 2000);
            this.$toast.fail("暂无排班");
          }
        } catch (error) {
          console.log(error);
          this.$hideLoad();
          this.$toast.fail("预约挂号失败，请重试");
        }
      }
    },
    //判断是否是今天，选择是否是挂号状态
    isToday(str) {
      let time = new Date();
      return (
        `${time.getFullYear()}-${
          (time.getMonth() + 1).length === 2
            ? time.getMonth() + 1
            : "0" + (time.getMonth() + 1)
        }-${time.getDate()}` === (str ? str.substr(0, 10) : "")
      );
    },
    //查询患者就诊卡信息
    async getmedicalcard() {
      try {
        this.$showLoad();
        let result = await this.$axios.get(
          `http://esrmyy.kmmds.top/api/medicalcard/getclientbyid?openId=${this.$local.get("openId")}`
        );
        this.medicalcardInfo = [...result.data];
      } catch (error) {
        console.log(error);
        this.$hideLoad();
        this.$toast.fail("获取就诊卡信息失败");
      }
    },
    //获取排班表信息
    async getSchedulheadList() {
      try {
        // let ret = await this.$axios.post("/register/queryschedulhead", {
        //   deptId: this.$route.query.deptId,
        //   docId: this.$route.query.docId,
        //   regLevelId: this.$route.query.regLevelId,
        //   dateBeg: this.$route.query.dateBeg,
        //   dateEnd: this.schedulheadInfo.visitEndTime,
        //   schedulId:this.$route.query.schedulId
        // });
        this.schedulheadInfo = JSON.parse(this.$route.query.schedul_info);
        console.log("排班信息："+JSON.stringify(this.schedulheadInfo));
        this.appointLimit =
          parseInt(this.schedulheadInfo.appointLimit) -
          parseInt(this.schedulheadInfo.appointReg) -
          parseInt(this.schedulheadInfo.appointReging);
        console.log(`可预约人数为${this.appointLimit}`);
        this.$hideLoad();
      } catch (error) {
        console.log(error);
        this.$hideLoad();
        this.$toast.fail("获取预约信息失败, 请重试");
      }
    },
  },
};
</script>
<style lang="scss" scope>
.main {
  .header {
    width: 100%;
    padding: 20px;
    background-color: #f5f6fa;
    .left {
      img {
        height: 50px;
        width: 50px;
        border-radius: 100px;
      }
    }
    .right {
      margin-left: 20px;
      .doc-info {
        justify-content: space-between;
        .doc-info-right {
          .doc-name {
            font-size: 18px;
            color: #576574;
          }
          .regLevel-name {
            margin-top: 5px;
            font-size: 16px;
            color: #a5b1c2;
          }
        }
        .status {
          color: #20bf6b;
          font-size: 16px;
          margin-top: 5px;
        }
      }
      .visit-time {
        margin-top: 16px;
        font-size: 14px;
        color: #4b6584;
      }
    }
  }
  .border {
    margin-top: 10px;
    .item {
      font-size: 16px;
      color: #0a3d62;
      padding: 20px 0;
      margin: 0 20px;
      line-height: 20px;
      border-bottom: 1px solid #f1f1f1;
      .money {
        color: #eb3b5a;
        font-weight: bold;
        font-size: 20px;
      }
    }
  }
  .footer {
    margin: 60px 0 40px;
    padding: 0 55px;
  }
  .popup {
    .van-popup {
      padding: 5px 10px;
      .van-cell__title {
        font-size: 16px;
        color: #0a3d62;
      }
    }
    .cancel-confirm {
      padding: 5px 6px 15px 10px;
      font-size: 17px;
      overflow: hidden;
      .cancel {
        color: #ea8685;
      }
      .confirm {
        color: #2d98da;
      }
    }
  }
}
</style>